import { $renderTemplate } from "../../render";
import { $cmsData, settings } from "../../common/setting";
import * as $ from "jquery";
import { cr, URLS } from "fire-wind-water";
export function afterView(cn, b): void {
  const hz = {
    isRun:false,
    skUserEnd() {
      if(this.isRun){
        return; //  不知道啥原因 走两次 先屏蔽一次
      }
      this.isRun = true;
      if (b) {
        $renderTemplate($cmsData.container);
        if (settings.isPreview) {
          // 设置页面标题
          cr.each($cmsData.container, (item: { [label: string]: any }) => {
            cr.each(item, (d) => {
              if (d.isMain === 1) {
                document.title =
                  (settings.category === "1"
                    ? settings.pcTitle
                    : settings.wapTitle) || d.name;
              }
            });
          });
        }
        $("body").append(settings.thirdCode);
      }
      setTimeout(() => {
        cn();
      }, 100);
    },
  };
  (window as any).$sk.template.module(hz);
}

export function afterImageLoad(cn) {
  const imgs = document.querySelectorAll("img");
  if (imgs.length === 0) {
    cn();
  }
  let index = 0;
  for (let i = 0; i < imgs.length; i++) {
    const im = new Image();
    im.onload = im.onerror = function () {
      index++;
      if (index >= imgs.length) {
        cn();
      }
    };
    im.src = imgs[i].src;
  }
}
